import DialogUtils from "../DialogUtils.js";
import DeleteBatchNotificationDialogCmp from "./DeleteBatchNotificationDialogCmp.js";

export default class DeleteBatchNotificationDialogHtml{

    /** @type {HTMLDialogElement}  */
    #dialog;
    #onOk = ()=>{}

    /** @param {number} selectedSize */
    show(selectedSize) {
        this.#dialog = document.body.insertAdjacentElement("beforeend", this.#createDialogElement(selectedSize));
        this.#addListeners();
        this.#dialog.showModal();
    }

    removeDialog(){
        this.#dialog.remove();
    }

    /** @param isVisible */
    toggleProgressBarVisibility(isVisible){
        this.#getProgressBar().style.display = isVisible ? "block" : "none"
    }

    #getProgressBar() {
        return this.#dialog.querySelector('.progress');
    }

    /** @param {function} callback */
    onOkCb(callback) {
        this.#onOk = callback;
    }

    #onOkClick() {
        const action = this.#getActOnNestedValue();
        if (!action)
            return
        this.#onOk(action);
    }

    #getActOnNestedValue() {
        const selectedRadio = document.querySelector('input[name="act-on-nested"]:checked')
        if (!selectedRadio){
            this.#toggleErrorVisibility(true);
            return;
        }
        return selectedRadio.value;
    }

    /** @returns {HTMLElement} */
    #toggleErrorVisibility(isVisible){
        this.#getErrorTextEl().classList.toggle('visually-hidden', !isVisible)
    }

    /** @returns {HTMLElement} */
    #getErrorTextEl() {
        return this.#dialog.querySelector('.delete-batch-notification-dialog__error-text')
    }

    /** @returns {HTMLElement} */
    #getOkButtonEl() {
        return this.#dialog.querySelector('button[data-action="ok"]')
    }

    /** @returns {HTMLElement} */
    #getCancelButtonEl() {
        return this.#dialog.querySelector('button[data-action="cancel"]')
    }

    #addListeners() {
        DialogUtils.setDefaultDialogListeners(this.#dialog);
        this.#getOkButtonEl().addEventListener('click', this.#onOkClick.bind(this));
        this.#getCancelButtonEl().addEventListener('click', this.removeDialog.bind(this));
        this.#dialog.addEventListener('close', this.removeDialog.bind(this));
        const actOnNestedInputs = this.#dialog.querySelectorAll('[name="act-on-nested"]');
        for (const input of actOnNestedInputs){
            input.addEventListener('input', this.#toggleErrorVisibility.bind(this, false))
        }
    }

    /**
     * @param {number} selectedSize
     * @returns {HTMLDialogElement}
     */
    #createDialogElement(selectedSize) {
        const el = document.createElement("dialog");
        el.classList.add('delete-batch-notification-dialog');
        el.innerHTML = this.#template(selectedSize);
        return el;
    }

    /** @param {number} selectedSize */
    #template(selectedSize){
        return `
        <div class="progress">
            <div class="indeterminate"></div>
        </div>
        <div class="delete-batch-notification-dialog__content dialog-content">
            
            <div class="delete-batch-notification-dialog__text-block">
                <p>Are you sure you want to permanently delete ${selectedSize} resources?</p>
            </div>
            <div class="delete-batch-notification-dialog__radio-buttons-block">
                <div class="delete-batch-notification-dialog__radio-buttons-row">
                    <input name="act-on-nested" type="radio" id="delete" 
                        value="${DeleteBatchNotificationDialogCmp.ACT_ON_NESTED_METHODS.DELETE}">
                    <label for="delete">Delete associated injections</label>
                </div>
                <div class="delete-batch-notification-dialog__radio-buttons-row">
                    <input name="act-on-nested" type="radio" id="unassign" 
                        value="${DeleteBatchNotificationDialogCmp.ACT_ON_NESTED_METHODS.UNASSIGN}">
                    <label for="unassign">Unassign associated injections</label>
                </div>
            </div>
            <div class="delete-batch-notification-dialog__error-block">
                <p class="delete-batch-notification-dialog__error-text visually-hidden">You should select option</p>
            </div>
        </div>
        <div class="delete-batch-notification-dialog__buttons dialog-buttons">
            <button data-action="ok" class="button button--contained btn-ok">Ok</button>
            <button data-action="cancel" class="button button--text btn-cancel">Cancel</button>
        </div>
        `
    }
}